import { all } from "redux-saga/effects";
import { xetTotNghiepLanXetSaga } from "./xetTotNghiepLanXetSaga";
import { xetTotNghiepPhamViSinhVienSaga } from "./xetTotNghiepPhamViSinhVienSaga";
import { xetTotNghiepSaga } from "./xetTotNghiepSaga";
import { danhSachTotNghiepSaga } from "./danhSachTotNghiepSaga";
import { danhSachNoTotNghiepSaga } from "./danhSachNoTotNghiepSaga";
import { danhSachHoanTotNghiepSaga } from "./danhSachHoanTotNghiepSaga";
import { khongDuDieuKienKetQuaHocTapXetTotNghiepSaga } from "./khongDuDieuKienKetQuaHocTapXetTotNghiepSaga";
import { duDieuKienKetQuaHocTapXetTotNghiepSaga } from "./duDieuKienKetQuaHocTapXetTotNghiepSaga";

export default function* xetTotNghiepSagaWrapper() {
  yield all([
   xetTotNghiepLanXetSaga(),
   xetTotNghiepPhamViSinhVienSaga(),
   xetTotNghiepSaga(),
   danhSachTotNghiepSaga(),
  danhSachNoTotNghiepSaga(),
  danhSachHoanTotNghiepSaga(),
  duDieuKienKetQuaHocTapXetTotNghiepSaga(),
  khongDuDieuKienKetQuaHocTapXetTotNghiepSaga(),
  ]);
}